import React from "react";
import { connect } from "react-redux";
import { reduxForm, Field } from "redux-form";
import { required, validatePhone, formatPhone } from "../utility";
import { Masks } from "../constants/enums";
import { MaterialTextField, MaterialMaskedTextField } from "./MaterialInput";
import MaterialAddressSuggest from "./MaterialAddressSuggest";
import SubmitButton from './SubmitButton';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Grid from '@material-ui/core/Grid';
import MenuItem from '@material-ui/core/MenuItem';
import Paper from '@material-ui/core/Paper';
import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';

class clientDetailsForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = { withAttorney: false };
    }
    toggleAttorney = () => {
        const { withAttorney } = this.state;
        this.setState({ withAttorney: !withAttorney });
    }
    render() {
        const { carId, car_number, client, isJur, editMode, onClientDetailsSubmit, handleSubmit, switchTab } = this.props;
        const { withAttorney } = this.state;
        return (
            <Paper className="common-paper" style={{ marginTop: 20, marginBottom: 20 }}>
                <form onSubmit={handleSubmit(data => onClientDetailsSubmit({ carId, carNumber: car_number, clientId: client._id }, data, () => switchTab(null, 1)))}>
                    <Grid container justify="center" spacing={16}>
                        <Grid item className="common-form common-column">
                            <Typography variant="h5" gutterBottom>Личные данные:</Typography>
                            <Field name="firstname"
                                   component={MaterialTextField}
                                   validate={required}
                                   label="Имя" />
                            <Field name="lastname"
                                   component={MaterialTextField}
                                   validate={required}
                                   label="Фамилия" />
                            <Field name="patronymic"
                                   component={MaterialTextField}
                                   validate={required}
                                   label="Отчество" />
                            <Field name="sex"
                                   select
                                   validate={required}
                                   component={MaterialTextField}
                                   label="Пол" >
                                <MenuItem value="M">Мужской</MenuItem>
                                <MenuItem value="F">Женский</MenuItem>
                            </Field>
                            <Field name="birthDate"
                                   component={MaterialMaskedTextField}
                                   validate={required}
                                   mask={Masks.date}
                                   label="Дата рождения" />
                            <Field name="birthPlace"
                                   component={MaterialTextField}
                                   validate={required}
                                   label="Место рождения" />
                            <Field name="phone"
                                   component={MaterialMaskedTextField}
                                   mask={Masks.phone}
                                   format={formatPhone}
                                   validate={validatePhone}
                                   placeholder="+7 (___) ___-__-__"
                                   label="Номер телефона" />
                            <Field name="email"
                                   component={MaterialTextField}
                                   label="Электронная почта" />
                            {!isJur &&
                                <FormControlLabel label="С доверенностью"
                                    control={
                                        <Switch checked={withAttorney}
                                                  onChange={this.toggleAttorney} />
                                    } />
                            }
                        </Grid>
                        <Grid item className="common-form common-column">
                            <Typography variant="h5" gutterBottom>Паспорт:</Typography>
                            <Field name="passportSerie"
                                   validate={required}
                                   component={MaterialMaskedTextField}
                                   mask={Masks.passportSerie}
                                   label="Серия паспорта" />
                            <Field name="passportNumber"
                                   component={MaterialMaskedTextField}
                                   validate={required}
                                   mask={Masks.passportNumber}
                                   label="Номер паспорта" />
                            <Field name="passportDate"
                                   component={MaterialMaskedTextField}
                                   validate={required}
                                   mask={Masks.date}
                                   label="Дата выдачи" />
                            <Field name="passportCode"
                                   component={MaterialMaskedTextField}
                                   validate={required}
                                   mask={Masks.code}
                                   label="Код подразделения" />
                            <Field component={MaterialAddressSuggest}
                                   validate={required}
                                   name="addressRegister"
                                   label="Адрес регистрации"/>
                            <Field name="citizenship"
                                   component={MaterialTextField}
                                   label="Гражданство" />
                            <Field name="passportIssued"
                                   rows={5}
                                   multiline
                                   component={MaterialTextField}
                                   validate={required}
                                   label="Кем выдан" />
                        </Grid>
                        {isJur &&
                            <Grid item className="common-form common-column">
                                <Typography variant="h5" gutterBottom>Юридическое лицо:</Typography>
                                <Field component={MaterialTextField}
                                       name="jurPerson.name"
                                       validate={required}
                                       label="Наименование" />
                                <Field component={MaterialMaskedTextField}
                                       mask={Masks.inn}
                                       validate={required}
                                       name="jurPerson.INN"
                                       label="ИНН" />
                                <Field component={MaterialMaskedTextField}
                                       mask={Masks.kpp}
                                       validate={required}
                                       name="jurPerson.KPP"
                                       label="КПП" />
                                <Field component={MaterialMaskedTextField}
                                       mask={Masks.ogrn}
                                       validate={required}
                                       name="jurPerson.OGRN"
                                       label="ОГРН" />
                                <Field component={MaterialTextField}
                                       name="jurPerson.bankName"
                                       validate={required}
                                       label="Банк" />
                                <Field component={MaterialTextField}
                                       name="jurPerson.bankAccount"
                                       validate={required}
                                       label="Р/С" />
                                <Field name="jurPerson.phone"
                                       component={MaterialMaskedTextField}
                                       mask={Masks.phone}
                                       format={formatPhone}
                                       validate={validatePhone}
                                       placeholder="+7 (___) ___-__-__"
                                       label="Телефон" />
                                <Field component={MaterialTextField}
                                       name="jurPerson.email"
                                       label="Электронная почта" />
                                <Field component={MaterialAddressSuggest}
                                       name="jurPerson.address"
                                       validate={required}
                                       label="Юридический адрес"/>
                                <Field component={MaterialTextField}
                                       name="jurPerson.personInCharge"
                                       validate={required}
                                       label="В лице..." />
                                <Field component={MaterialTextField}
                                       name="jurPerson.basis"
                                       validate={required}
                                       label="Действует на основании..." />
                            </Grid>
                        }
                        { withAttorney &&
                            <Grid item className="common-form common-column">
                                <Typography variant="h5" gutterBottom>Доверитель:</Typography>
                                <Field component={MaterialTextField}
                                       name="attorney.principalFirstname"
                                       validate={required}
                                       label="Имя" />
                                <Field component={MaterialTextField}
                                       name="attorney.principalSecondname"
                                       validate={required}
                                       label="Фамилия" />
                                <Field component={MaterialTextField}
                                       name="attorney.principalThirdname"
                                       validate={required}
                                       label="Отчество" />
                                <Field name="attorney.principalSex"
                                       select
                                       component={MaterialTextField}
                                       validate={required}
                                       label="Пол доверителя" >
                                    <MenuItem value="M">Мужской</MenuItem>
                                    <MenuItem value="F">Женский</MenuItem>
                                </Field>
                                <Field name="attorney.principalBirthDate"
                                       component={MaterialMaskedTextField}
                                       validate={required}
                                       mask={Masks.date}
                                       label="Дата рождения" />
                                <Field name="attorney.principalPassportSerie"
                                       component={MaterialMaskedTextField}
                                       validate={required}
                                       mask={Masks.passportSerie}
                                       label="Серия паспорта" />
                                <Field name="attorney.principalPassportNumber"
                                       component={MaterialMaskedTextField}
                                       validate={required}
                                       mask={Masks.passportNumber}
                                       label="Номер паспорта" />
                                <Field name="attorney.principalPassportDate"
                                       component={MaterialMaskedTextField}
                                       validate={required}
                                       mask={Masks.date}
                                       label="Дата выдачи" />
                                <Field name="attorney.principalPassportCode"
                                       component={MaterialMaskedTextField}
                                       validate={required}
                                       mask={Masks.code}
                                       label="Код подразделения" />
                                <Field name="attorney.principalPassportIssued"
                                       component={MaterialTextField}
                                       validate={required}
                                       label="Кем выдан" />
                                <Field component={MaterialAddressSuggest}
                                       name="attorney.principalAddressRegister"
                                       validate={required}
                                       label="Адрес регистрации"/>
                            </Grid>
                        }
                        { withAttorney &&
                            <Grid item className="common-form common-column">
                                <Typography variant="h5" gutterBottom>Доверенность:</Typography>
                                <Field component={MaterialTextField}
                                       name="attorney.attorneyNumber"
                                       validate={required}
                                       label="Номер" />
                                <Field component={MaterialTextField}
                                       name="attorney.notaryIssued"
                                       validate={required}
                                       label="Кем выдано" />
                                <Field component={MaterialMaskedTextField}
                                       mask={Masks.date}
                                       validate={required}
                                       name="attorney.notaryDate"
                                       label="Дата выдачи" />
                                <Field component={MaterialTextField}
                                       validate={required}
                                       name="attorney.notarySecondname"
                                       label="Фамилия нотариуса" />
                                <Field component={MaterialTextField}
                                       name="attorney.notaryFirstname"
                                       validate={required}
                                       label="Имя нотариуса" />
                                <Field component={MaterialTextField}
                                       name="attorney.notaryThirdname"
                                       validate={required}
                                       label="Отчество нотариуса" />
                                <Field name="attorney.notarySex"
                                       select
                                       component={MaterialTextField}
                                       validate={required}
                                       label="Пол нотариуса" >
                                    <MenuItem value="M">Мужской</MenuItem>
                                    <MenuItem value="F">Женский</MenuItem>
                                </Field>
                            </Grid>
                        }
                    </Grid>
                    <SubmitButton label={ editMode ? "Сохранить" : "Далее" } />
                </form>
            </Paper>
        );
    }
}

const ClientDetailsForm = connect(
    (state, props) => {
        const { client: { firstname, secondname, thirdname, birthDate, phone, email, address, passport: {serie, number, date} = {} }, clientDetails } = props;
        return {
            initialValues: Object.assign({
                lastname: secondname,
                firstname: firstname,
                patronymic: thirdname,
                passportSerie: serie,
                passportNumber: number,
                passportDate: date,
                addressRegister: address,
                phone,
                birthDate,
                email,
                citizenship: "РФ"
            }, clientDetails),
        };
    },
)(reduxForm({
    form: "client-details-form",
    enableReinitialize: true,
})(clientDetailsForm));

export default ClientDetailsForm;



// WEBPACK FOOTER //
// ./src/components/ClientDetailsForm.js